<template>
  <div class="cartItem col-12">
    <div class="row">
      <div class="col-12">
        <span class="col-12 col-sm-9 col-md-10 title-container">
          <router-link
            class="productTitle"
            :to="{name:'product', params:{product:item.product.id}}">
              {{item.product.title}} - {{item.product.product_code}}
          </router-link>
        </span>
        <span class="col-12 col-sm-3 col-md-2 text-right text-sm-left title-container remove-button-container">
          <button
            @click="() => {this.removeFromCart()}"
            class="btn btn-sm btn-outline-warning remove-button"
          >Remove</button>
        </span>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-3 text-center">
        <img
          v-if="item.product.images && item.product.images[0]"
          :src="imageUrl(item.product.images[0].sizes, 'small')"
          class="cartImage"
        >
      </div>
      <div class="col-12 col-sm-4 col-md-3 text-center alignCenter">
        <div class="heading">Quantity</div>
        <QuantitySelector :step="parseInt(item.product.pack_size) || 1" :min="parseInt(item.product.pack_size) || 1" v-model="itemQuantity" class="quantitySelector"/>
      </div>
      <div class="col-6 col-sm-4 col-md-3 text-center alignCenter">
        <div class="heading">Your Price</div>
        {{CurrencyFormatter(item.product.member_price.price)}}
      </div>
        <!-- {{item}} -->
      <div class="col-6 col-sm-4 col-md-3 text-center alignCenter">
        <div class="heading">Subtotal</div>
        {{CurrencyFormatter(item.line_total)}}
      </div>
  </div>
</div>
</template>

<script>
import { imageUrl, CurrencyFormatter } from "@/utils";

import QuantitySelector from "@/components/QuantitySelector";
import { makeProductObject } from "@/gaUtils";

export default {
  name: "CartItem",
  components: {
    QuantitySelector
  },
  data(){
    return{
      itemQuantity: null,
    }
  },
  created(){
    this.itemQuantity = parseInt(this.item.settings.quantity);
    //console.log(this.item)
  },
  props: ["item"],
  methods: {
    imageUrl,
    CurrencyFormatter,
    removeFromCart() {
      this.$store.dispatch('cart/removeItem', {productId: this.item.product.id})
      this.$gtm.trackEvent({
        event: "removeFromCart",
        ecommerce: {
          currencyCode: "NZD",
          remove: {
            products: [makeProductObject(this.item.product, this.itemQuantity)]
          }
        }
      })
    }
  },
  watch:{
    itemQuantity(newVal, oldVal){
      if(oldVal === null){
        return;
      }
      this.$store.dispatch("cart/setQuantity", {productId: this.item.product.id, quantity: newVal})
    },
  }
};
</script>

<style lang="scss" scoped>
.cartItem{
  // border-top:2px grey solid;
  margin-top:10px;
  padding:5px;

  .productTitle{
    color:$CTred;
    font-size:1.1em;
  }

  img.cartImage{
    max-width:100%;
    height:auto;
    object-fit:contain;
    max-height:100%;
  }

  select{
    max-width:100%;
  }

  .remove-button{
    font-size:0.6em;
    padding-left: 10px;
    padding-right:10px;
  }

  .title-container{
    display: inline-flex !important;
    padding-bottom: 20px;
  }
  .heading{
    font-weight: bold;
  }
}

@include media-breakpoint-up(lg) {
  .alignCenter {
    align-self: center;
  }
}
</style>
